angular.module('buildingSpecialistsModule').component('buildingSpecialistsList', {
    templateUrl: 'buildingSpecialistsList/buildingSpecialistsList.html',
    bindings: {
        rpc: '@',
        leadkitUrl: '@',
        isAgent: '@'
    },
    controller: ['$sce', '$element', '$timeout', '$interval', 'crResourcesService', function ($sce, $element, $timeout, $interval, crResourcesService) {
        var self = this;
        self.buildingSpecialists = [];
        self.isLoaded = false;
        self.resourcesPath = Res_i;

        var CYCLE_DURATION = 3000; // ms per photo
        var photoIntervals = [];

        // Function to determine initial fallback image
        self.getSpecialistImage = function (specialist) {
            return specialist.photo_url || specialist.photo_url_alt || specialist.photo_url_ds || '';
        };

        // Fallback function to handle broken images dynamically
        // self.handleImageError = function (imgElement) {
        //     var scope = angular.element(imgElement).scope();
        //     var specialist = scope.specialist; // Retrieve specialist from scope

        //     if (!specialist) {
        //         console.warn("Specialist is undefined");
        //         return;
        //     }

        //     var currentSrc = imgElement.src;

        //     if (currentSrc === specialist.photo_url && specialist.photo_url_alt) {
        //         imgElement.src = specialist.photo_url_alt;
        //     } else if (currentSrc === specialist.photo_url_alt && specialist.photo_url_ds) {
        //         imgElement.src = specialist.photo_url_ds;
        //     } else {
        //         imgElement.style.display = 'none'; // Hide if all fail
        //     }
        // };


        self.initPhotoCyclers = function () {
            self.buildingSpecialists.forEach(function (specialist) {
                if (!specialist.team_name) return;
                if (specialist.finalPhotoUrl) return;
                if (!specialist.agent_photos || specialist.agent_photos.length <= 1) return;

                specialist._currentPhotoIndex = 0;
                specialist._cyclerActive = true;

                var handle = $interval(function () {
                    specialist._currentPhotoIndex =
                        (specialist._currentPhotoIndex + 1) % specialist.agent_photos.length;
                }, CYCLE_DURATION);

                photoIntervals.push(handle);
            });
        };

        self.loadListingHistory = function () {
            crResourcesService.get(self.rpc).$promise.then((val) => {
                if (val.items) {
                    self.buildingSpecialists = val.items.map(specialist => {
                        specialist.finalPhotoUrl = self.getSpecialistImage(specialist);
                        return specialist;
                    });
                    self.isLoaded = true;

                    $timeout(function () {
                        self.initPhotoCyclers();
                    });
                }
            });
        };
        self.loadListingHistory();

        self.$onDestroy = function () {
            photoIntervals.forEach(function (handle) {
                $interval.cancel(handle);
            });
            photoIntervals = [];
        };
    }],
});
